import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import Message from "../Message";

function MessagesList() {
  const wrapperRef = useRef(null);
  const messagesRef = useRef(null);

  const filterMessages = (messages) => {
    const first = messages.findIndex((msg) => msg.type !== "newRemoteFeed");
    return first < 0 ? [] : messages.slice(first);
  };

  const mustScroll = (message) => {
    const threshold = 100;
    const wrapper = wrapperRef.current;

    const wrapperViewBottom = wrapper.scrollTop + wrapper.clientHeight;
    const msgTop = message.offsetTop;
    const msgBottom = msgTop + message.clientHeight;

    return (
      msgBottom > wrapperViewBottom && msgTop <= wrapperViewBottom + threshold
    );
  };

  const updateScroll = () => {
    const lastMsg = messagesRef.current.lastChild;

    if (!lastMsg || !mustScroll(lastMsg)) return;

    lastMsg.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  useEffect(updateScroll);

  const messages = filterMessages(useSelector((state) => state.messages));

  return (
    <div ref={wrapperRef} className="h-full overflow-y-auto">
      <ul ref={messagesRef}>
        {messages.map((m, index) => (
          <Message key={index} onRender={updateScroll} {...m} />
        ))}
      </ul>
    </div>
  );
}

export default MessagesList;
